// extracted by css-extract-rspack-plugin
export default {"root":"H5etV"};